export * from './DishSkeleton';
